{
  "tabs": {
    "chat": "Chat",
    "reminders": "Herinneringen",
    "calendar": "Agenda",
    "settings": "Instellingen"
  },
  "common": {
    "cancel": "Annuleren",
    "save": "Opslaan",
    "confirm": "Bevestigen",
    "delete": "Verwijderen",
    "back": "Terug",
    "close": "Sluiten",
    "edit": "Bewerken",
    "search": "Zoeken",
    "all": "Alles",
    "loading": "Laden...",
    "error": "Er is iets misgegaan",
    "notFound": "Niet gevonden",
    "tryAgain": "Probeer het opnieuw",
    "retry": "Opnieuw",
    "undo": "Ongedaan maken",
    "pullToRefresh": "Trek om te verversen",
    "justNow": "zojuist"
  },
  "auth": {
    "welcome": "Welkom bij FishMemory",
    "tagline": "Je WhatsApp herinneringsassistent, nu in je zak.",
    "subtitle": "Je WhatsApp herinneringsassistent, nu in je zak.",
    "phoneLabel": "Je WhatsApp-nummer",
    "phoneHint": "We sturen een verificatiecode via WhatsApp",
    "invalidPhone": "Voer een geldig telefoonnummer in",
    "continue": "Doorgaan",
    "enterPhone": "Voer je WhatsApp-nummer in",
    "phonePlaceholder": "Telefoonnummer",
    "sendCode": "Code verzenden",
    "verifyTitle": "Verifieer je nummer",
    "otpSentTo": "Een 6-cijferige code is verzonden naar {{phone}} via WhatsApp",
    "enterFullCode": "Voer alle 6 cijfers in",
    "invalidOtp": "Ongeldige code. Probeer het opnieuw.",
    "otpFailed": "Verzenden van code mislukt. Probeer opnieuw.",
    "otpResent": "Code opnieuw verzonden",
    "resendIn": "Opnieuw verzenden over {{seconds}}s",
    "resendCode": "Code opnieuw verzenden",
    "enterOtp": "Voer de code in die naar je WhatsApp is gestuurd",
    "verify": "Verifiëren",
    "resend": "Code opnieuw verzenden",
    "wrongNumber": "Verkeerd nummer?",
    "backToPhone": "Terug naar telefoon",
    "editPhone": "Telefoonnummer bewerken",
    "error": "Fout",
    "setupTitle": "Laten we het instellen",
    "setupSubtitle": "Je kunt dit later altijd aanpassen in Instellingen",
    "namePlaceholder": "Je naam",
    "letsGo": "Instellen voltooien",
    "skipForNow": "Nu overslaan"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Typ een bericht...",
    "inputPlaceholder": "Typ een bericht...",
    "typing": "FishMemory is aan het typen...",
    "online": "Online",
    "connecting": "Verbinden...",
    "reconnecting": "Opnieuw verbinden...",
    "offline": "Offline",
    "empty": "Begin een gesprek",
    "emptyHint": "Maak herinneringen, bekijk je agenda of vraag om hulp.",
    "emptyAction": "Stuur een voorbeeldherinnering",
    "actions": "Chatacties",
    "keep": "Berichten bewaren",
    "clearTitle": "Chat wissen",
    "clearConfirm": "Alle berichten van dit apparaat verwijderen? Dit kan niet ongedaan worden gemaakt.",
    "clear": "Chat wissen",
    "optionSelected": "Geselecteerd: {{label}}",
    "sendingSelection": "Verzenden...",
    "connectionLost": "Opnieuw verbinden..."
  },
  "reminders": {
    "title": "Mijn Herinneringen",
    "active": "Actief",
    "today": "Vandaag",
    "thisWeek": "Deze week",
    "history": "Geschiedenis",
    "items": "items",
    "emptyTitle": "Nog geen herinneringen",
    "emptySubtitle": "Maak er een aan via chat, dan verschijnt die hier.",
    "emptyAction": "Open chat",
    "filterActive": "Actief",
    "filterToday": "Vandaag",
    "filterWeek": "Deze week",
    "filterHistory": "Geschiedenis",
    "emptyState": "Nog geen herinneringen. Begin met chatten!",
    "swipeDone": "Gereed",
    "swipeSnooze": "Snooze",
    "swipeDelete": "Verwijderen",
    "search": "Herinneringen zoeken...",
    "upcoming": "Aankomend",
    "completed": "Voltooid",
    "overdue": "Verlopen",
    "tomorrow": "Morgen",
    "synced": "Gesynchroniseerd {{value}}",
    "swipeHint": "Veeg een herinnering voor meer acties",
    "noResults": "Geen herinneringen gevonden",
    "noResultsHint": "Probeer een ander zoekwoord of wis de zoekopdracht",
    "deleteAllFailed": "Kon niet alle herinneringen verwijderen"
  },
  "calendar": {
    "title": "Agenda",
    "today": "Vandaag",
    "tomorrow": "Morgen",
    "completed": "gereed",
    "noEvents": "Niets gepland",
    "noEventsSubtitle": "Kies een datum om herinneringen en agenda-items te zien.",
    "googleEvent": "Google Agenda",
    "legendActive": "Actief",
    "legendRecurring": "Terugkerend",
    "legendDone": "Gereed",
    "legendGoogle": "Google",
    "previousMonth": "Vorige maand",
    "nextMonth": "Volgende maand",
    "previousYear": "Vorig jaar",
    "nextYear": "Volgend jaar",
    "goToToday": "Ga naar vandaag",
    "all": "Alles",
    "active": "Actief",
    "done": "Gereed",
    "paused": "Gepauzeerd"
  },
  "settings": {
    "title": "Instellingen",
    "profile": "Profiel",
    "name": "Weergavenaam",
    "enterName": "Voer je naam in",
    "language": "Taal",
    "uiLanguage": "App-taal",
    "uiLanguageHelp": "Verandert de app-interface, agendalabels en layoutrichting alleen op dit apparaat.",
    "serverLanguage": "Chattaal",
    "serverLanguageHelp": "Verandert de taal van serverantwoorden en herinneringsberichten voor je account.",
    "timezone": "Tijdzone",
    "currentTimezone": "Huidige tijdzone",
    "timezoneHelp": "Alle herinneringstijden worden weergegeven in deze tijdzone.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Tijdzone opslaan",
    "timezoneSaved": "Tijdzone bijgewerkt",
    "detect": "Detecteren",
    "detectFailed": "Kon tijdzone niet detecteren",
    "autoDetect": "Automatisch detecteren via GPS",
    "notifications": "Meldingen",
    "notificationsHelp": "Herinneringen voor opvolging regelen herhaalde meldingen na levering. Apparaatmeldingen beheer je via telefooninstellingen.",
    "pushEnabled": "Pushmeldingen",
    "autoDoneOnFire": "Automatisch als gereed markeren bij afgaan",
    "autoDoneOnFireDesc": "Als uit, blijven herinneringen actief tot je ze als gereed markeert.",
    "googleCalendar": "Google Agenda",
    "google": "Google Agenda",
    "googleConnected": "Verbonden",
    "googleDisconnected": "Niet verbonden",
    "googleConnectedHelp": "Nieuwe herinneringen kunnen automatisch met je agenda worden gesynchroniseerd.",
    "googleDisconnectedHelp": "Verbind Google Agenda om herinneringen en afspraken te synchroniseren.",
    "googleConnectFailed": "Verbinden met Google Agenda mislukt",
    "connected": "Verbonden",
    "disconnected": "Niet verbonden",
    "connect": "Verbinden",
    "disconnect": "Verbreken",
    "autoSync": "Automatisch nieuwe herinneringen synchroniseren",
    "autosync": "Automatisch nieuwe herinneringen synchroniseren",
    "subscription": "Abonnement",
    "trialUsed": "Proefperiode: {{used}}/{{total}} gebruikt",
    "trialStatus": "Proefperiode beschikbaar",
    "activeStatus": "Actief abonnement",
    "expiredStatus": "Abonnement verlopen",
    "unsubscribedStatus": "Niet geabonneerd",
    "about": "Over",
    "version": "Versie",
    "logout": "Uitloggen",
    "logoutTitle": "Uitloggen",
    "logoutConfirm": "Weet je zeker dat je wilt uitloggen?",
    "noName": "Geen naam ingesteld",
    "serverConnection": "Serververbinding",
    "serverUrl": "Server-URL",
    "serverEdit": "Bewerken",
    "saveReconnect": "Opslaan en opnieuw verbinden",
    "resetDefault": "Standaard herstellen",
    "invalidServerUrlTitle": "Ongeldige server-URL",
    "invalidServerUrlMessage": "Voer een geldige http- of https-server-URL in, bijvoorbeeld https://example.com",
    "uiLanguageChangeFailed": "App-taal wijzigen mislukt. Probeer het opnieuw.",
    "serverLanguageChangeFailed": "Chattaal wijzigen mislukt. Probeer het opnieuw.",
    "timezoneChangeFailed": "Tijdzone wijzigen mislukt. Probeer het opnieuw.",
    "autoSyncChangeFailed": "Automatisch synchroniseren bijwerken mislukt. Probeer het opnieuw.",
    "nameChangeFailed": "Weergavenaam bijwerken mislukt. Probeer het opnieuw.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Herinneringsdetails",
    "editTime": "Tijd bewerken",
    "rename": "Naam wijzigen",
    "snooze": "Snooze",
    "snooze15": "Snooze 15 minuten",
    "pause": "Pauzeren",
    "pauseReminder": "Herinnering pauzeren",
    "resume": "Hervatten",
    "resumeReminder": "Herinnering hervatten",
    "skip": "Volgende overslaan",
    "skipOccurrence": "Deze keer overslaan",
    "syncGoogle": "Synchroniseren met Google",
    "delete": "Verwijderen",
    "deleteTitle": "Herinnering verwijderen",
    "deleteConfirm": "Deze herinnering wordt permanent verwijderd.",
    "deleteRecurringTitle": "Terugkerende herinnering verwijderen",
    "deleteRecurringMessage": "Wil je deze keer overslaan of de hele reeks verwijderen?",
    "deleteThisOccurrence": "Deze keer overslaan",
    "deleteEntireSeries": "Hele reeks verwijderen",
    "done": "Gereed",
    "markDone": "Markeren als gereed",
    "undo": "Herstellen",
    "undoPrompt": "Weer actief nodig? Herstel nu.",
    "recurring": "Terugkerend",
    "nextRun": "Volgende keer",
    "oneTime": "Eenmalig",
    "pending": "In afwachting",
    "sent": "Verzonden",
    "paused": "Gepauzeerd",
    "active": "Actief",
    "snoozed": "Gesnoozed",
    "localTime": "Weergegeven in je lokale tijd",
    "recurrence": "Herhaling",
    "created": "Aangemaakt",
    "tags": "Labels",
    "fireCount": "Aantal keren afgaan",
    "actions": "Acties",
    "none": "Geen",
    "snoozeFailed": "Snoozen van herinnering mislukt",
    "pauseFailed": "Pauzeren van herinnering mislukt",
    "resumeFailed": "Hervatten van herinnering mislukt",
    "skipFailed": "Overslaan van herinnering mislukt",
    "doneFailed": "Markeren als gereed mislukt",
    "undoFailed": "Herstellen van herinneringsstatus mislukt",
    "deleteFailed": "Verwijderen van herinnering mislukt",
    "rescheduleTitle": "Herschikken?",
    "rescheduleMsg": "Deze herinnering is verlopen. Wil je hem herschikken?",
    "reschedule15": "Over 15 minuten",
    "reschedule60": "Over 1 uur",
    "keepOverdue": "Zo houden"
  },
  "onboarding": {
    "slide1Title": "Welkom bij FishMemory",
    "slide1Sub": "Je persoonlijke herinneringsassistent — aangedreven door WhatsApp en gemaakt voor je zak.",
    "slide2Title": "Chat gewoon natuurlijk",
    "slide2Sub": "Typ herinneringen zoals je denkt: \"Herinner me eraan mama te bellen morgen om 15:00\" — wij regelen de rest.",
    "slide3Title": "Mis nooit iets",
    "slide3Sub": "Ontvang tijdige meldingen, organiseer met labels en blijf op de hoogte van alles wat telt.",
    "getStarted": "Beginnen",
    "next": "Volgende",
    "firstReminderTitle": "Maak je eerste herinnering!",
    "firstReminderHint": "Probeer iets te typen zoals:",
    "firstReminderExample": "Herinner me om morgen om 9 uur water te drinken",
    "gotIt": "Begrepen!",
    "notifRationaleTitle": "Blijf op tijd",
    "notifRationaleBody": "FishMemory heeft meldingen nodig om je op tijd te herinneren. Je krijgt alleen meldingen voor herinneringen die je maakt.",
    "notifRationaleAllow": "Meldingen inschakelen",
    "notifRationaleLater": "Misschien later",
    "swipeHint": "Veeg naar rechts voor snelle acties →",
    "calendarDragHint": "Sleep om uit te breiden ↕"
  }
}
